import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ec4fa0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = { class: "question-list-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "question-row-header" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "question-list" }
const _hoisted_8 = {
  key: 1,
  class: "question-item"
}

import { computed, ref, watchEffect } from 'vue'
import { getQuestion, getQuestionRowByIds } from '@/api/common'
import { QuestionConfig, QuestionrowConfig } from '@/types'
import { ERR_SUCCESS } from '@/api/config'
import QuestionDetail from '@/components/question/Detail.vue'
import { sanitizeHTML } from '@/hooks/utils/helper'
import Pagination from '@/components/common/Pagination.vue'
import debounce from 'lodash/debounce'


export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  props: ['singleSelect', 'multipleSelect', 'area'],
  setup(__props) {

const dataList = ref<QuestionConfig[]>([])
const questionRowList = ref<QuestionrowConfig[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(12)
const totalSize = ref<number>(0)
const processedQuestionRows = new Set<number>()

// eslint-disable-next-line no-undef
const props = __props

const keyword = ref('')
const searchKeyword = ref('')

function handleKeywordChange () {
  searchKeyword.value = keyword.value
}

const debouncedHandleKeywordChange = debounce(handleKeywordChange, 1000)

function filteredQuestions (itemId: number): QuestionConfig[] {
  return dataList.value.filter(question => question.questionrow === itemId)
}

function getQuestionRowContent (index: number): string {
  const item = questionRowList.value.find((item) => item.id === index)
  return item?.qrquestion || ''
}

const filteredDataList = computed(() => {
  return dataList.value.filter((item) => {
    if (item.questionrow) {
      if (processedQuestionRows.has(item.questionrow)) {
        return false
      } else {
        processedQuestionRows.add(item.questionrow)
        return true
      }
    }
    return true
  })
})

async function fetchData () {
  const {
    subject = null,
    period = null
  } = props.singleSelect || {}
  const {
    platform = [],
    edition = [],
    year = [],
    grade = [],
    term = []
  } = props.multipleSelect || {}

  processedQuestionRows.clear()

  try {
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      platform: Array.isArray(platform) ? platform.join(',') : platform,
      grade: Array.isArray(grade) ? grade.join(',') : grade,
      edition: Array.isArray(edition) ? edition.join(',') : edition,
      year: Array.isArray(year) ? year.join(',') : year,
      term: Array.isArray(term) ? term.join(',') : term,
      keyword: searchKeyword.value,
      period,
      subject,
      area: Array.isArray(props.area) ? props.area.join(',') : props.area
    }
    const {
      code,
      result: {
        items: data,
        total
      }
    } = await getQuestion({ params })
    if (code === ERR_SUCCESS && data) {
      let questionNoCounter = 1
      // Set the processed data to dataList
      dataList.value = data.map(item => {
        return {
          ...item,
          questionNo: questionNoCounter++
        }
      })
      totalSize.value = total

      const idsString = [...new Set(data.map(item => item.questionrow).filter(Boolean))].join(',') || null
      if (idsString) {
        const {
          code,
          result: questionRows
        } = await getQuestionRowByIds(idsString)
        if (code === ERR_SUCCESS && questionRows) {
          questionRowList.value = questionRows
        }
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

watchEffect(() => {
  fetchData()
})


return (_ctx: any,_cache: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        clearable: "",
        placeholder: "关键词 ...",
        onChange: _unref(debouncedHandleKeywordChange)
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_icon, {
            type: "button",
            onClick: handleKeywordChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Search)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_el_empty, {
          "image-size": 100,
          description: "暂无数据"
        })
      ], 512), [
        [_vShow, filteredDataList.value.length === 0]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDataList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "question-container question-item"
        }, [
          (item.questionrow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_tag, {
                    effect: "dark",
                    round: "",
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("题组 " + _toDisplayString(index + 1), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", {
                    class: "question-row-header-content",
                    innerHTML: _unref(sanitizeHTML)(getQuestionRowContent(item.questionrow))
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredQuestions(item.questionrow), (question, qIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: qIndex,
                      class: "question-item"
                    }, [
                      _createVNode(QuestionDetail, { item: question }, null, 8, ["item"])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(QuestionDetail, { item: item }, null, 8, ["item"])
              ]))
        ]))
      }), 128))
    ]),
    _createVNode(Pagination, {
      "current-page": currentPage.value,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
      "total-size": totalSize.value
    }, null, 8, ["current-page", "page-size", "total-size"])
  ]))
}
}

})